import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI

function getResumeByRfc (token_auth, rfc) {
    
    const resource = `/fas/savings/get_resume_by_rfc`
    const API_URL = `${host}${resource}`
    
    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        rfc: rfc
    }
    
    return get(API_URL, { params, config })
}

function normalRenounce({token_auth, rfc, name, middle_name, paternal_name, maternal_name, email, cellphone, account_number, bank_name, withdraw_type}) {
    const resource = `/fas/withdraw_saving_request/create`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        rfc: rfc,
        name: name,
        middle_name: middle_name,
        maternal_name: maternal_name,
        paternal_name: paternal_name,
        email: email,
        cellphone: cellphone,
        account_number: account_number,
        bank_name: bank_name,
        withdraw_type: withdraw_type
    }

    return post(API_URL, params, config)
}

function renounceByDeath({token_auth, rfc, name, middle_name, paternal_name, maternal_name, 
    email, cellphone, account_number, bank_name, withdraw_type, beneficiary_name, beneficiary_middle_name, 
    beneficiary_paternal_name, beneficiary_maternal_name}) {
    const resource = `/fas/withdraw_saving_request/create`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        rfc: rfc,
        name: name,
        middle_name: middle_name,
        maternal_name: maternal_name,
        paternal_name: paternal_name,
        email: email,
        cellphone: cellphone,
        account_number: account_number,
        bank_name: bank_name,
        withdraw_type: withdraw_type,
        beneficiary_name: beneficiary_name,
        beneficiary_middle_name: beneficiary_middle_name,
        beneficiary_paternal_name: beneficiary_paternal_name,
        beneficiary_maternal_name: beneficiary_maternal_name
    }

    return post(API_URL, params, config)
}

function getRenounce (token_auth, rfc) {
    
    const resource = `/fas/withdraw_saving_request/get_pending_by_rfc`
    const API_URL = `${host}${resource}`
    
    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        rfc: rfc
    }
    
    return get(API_URL, { params, config })
}

function getRenounceRequests (token_auth) {
    
    const resource = `/fas/withdraw_saving_request/get_list`
    const API_URL = `${host}${resource}`
    
    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth
    }
    
    return get(API_URL, { params, config })
}

function acceptRenounceRequest(token_auth, id) {
    const resource = `/fas/withdraw_saving_request/accept`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        id: id
    }

    return post(API_URL, params, config)
}

function rejectRenounceRequest(token_auth, id) {
    const resource = `/fas/withdraw_saving_request/reject`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        id: id
    }

    return post(API_URL, params, config)
}

function cancelRenounceRequest(token_auth, id) {
    const resource = `/fas/withdraw_saving_request/cancel`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        id: id
    }

    return post(API_URL, params, config)
}
    
export {
    getResumeByRfc,
    normalRenounce,
    renounceByDeath,
    getRenounce,
    getRenounceRequests,
    acceptRenounceRequest,
    rejectRenounceRequest,
    cancelRenounceRequest
}